import React from "react";
import {offeringSummary, incomeAndExpenses, rentRoll, getRentRoll} from "./tables";
import {getOfferingSummaryData, getIncomeAndExpenses} from "../PrintMultiTenant/tables";
import BaseTabComponent from "../UnderwritingMultiTenant/tabs-components/BaseTabComponent";

let cloneDeep = require('lodash.clonedeep');

export default class PrintMultiTenant extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                offeringSummary: offeringSummary,
                incomeAndExpenses: incomeAndExpenses,
                rentRoll: rentRoll
            },
        }
    }

    async createMap(propertyMapProps) {
        let {default: mapboxgl} = await import('mapbox-gl/dist/mapbox-gl.js');

        mapboxgl.accessToken = 'pk.eyJ1IjoiYW5kcmVlYW1pcmNlYSIsImEiOiJja2lpa25rNzQwYWV0MnNxcGdscDVnbGc3In0.YW3ma8Gr7xlYFsAfLwTL1A';
        let map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [propertyMapProps.LONGITUDE, propertyMapProps.LATITUDE],
            zoom: 12,
            minzoom: 12,
            maxzoom: 12,
        });

        let el = document.createElement('div');
        el.className = 'marker';
        el.style.backgroundImage = `url(${arc.path.media}marker-star.svg)`;

        new mapboxgl.Marker(el).setLngLat([propertyMapProps.LONGITUDE, propertyMapProps.LATITUDE])
            .addTo(map);

        const propertyName = propertyMapProps.NAME;
        new mapboxgl.Popup()
            .setLngLat([propertyMapProps.LONGITUDE, propertyMapProps.LATITUDE])
            .setHTML(propertyName)
            .addTo(map);
    }

    componentDidMount() {
        if (!document.querySelector('#mapboxstyles')) {
            const link = document.createElement('link');
            link.href = 'https://api.mapbox.com/mapbox-gl-js/v2.0.0/mapbox-gl.css?optimize=true';
            link.rel = 'stylesheet';
            link.id = 'mapboxstyles';
            document.head.appendChild(link)
        }
        setTimeout(() => this.createMap(this.props.propertyMapProps), 1000);
    }

    async componentWillReceiveProps(nextProps) {
        const data = cloneDeep(this.state.data);

        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(nextProps.tabs);
        data.offeringSummary.rows = getOfferingSummaryData(nextProps.tabs, precomputedValues);
        data.incomeAndExpenses = getIncomeAndExpenses(nextProps.tabs, precomputedValues);
        data.rentRoll = getRentRoll(nextProps.tabs, precomputedValues);

        this.setState({data});
    }

    static renderTable(table) {
        return (
            <div className='table'>
                <div className='title'>{table.name}</div>
                {table.rows ?
                    table.rows.map((row, index) => {
                        return (
                            <div key={index} className={`row${index % 2 !== 0 ? ' white' : ''}`}>
                                <div>{row.label}</div>
                                <div>{row.value}</div>
                            </div>
                        )
                    })
                    : null
                }
            </div>
        );
    }

    static renderTableMatrix(table, tableClassName) {
        return (
            <div className={`table ${tableClassName === 'income-expenses' ? 'big-margin ' : ''}${tableClassName}`}>
                {table.header ?
                    <div className='row table-header'>
                        {table.header.map((cell, index) => {
                            return (
                                <div key={index} className='cell first-letter'>{cell}</div>
                            )
                        })}
                    </div>
                    : null
                }
                {table.rows.map((row, index) => {
                    return (
                        <div key={index} className={`row${index % 2 !== 0 ? ' white' : ''}`}>
                            {row.valueCells.map((cell, cellIndex) => {
                                return (
                                    <div key={`${index}-${cellIndex}`} className='cell'>{cell.value}</div>
                                )
                            })}
                        </div>
                    )
                })}
                {table.footer ?
                    <div className={`${tableClassName === 'rent-roll' ? 'column' : 'row'} table-footer`}>
                        {table.footer.map((elem, index) => {
                            if (Array.isArray(elem)) {
                                return (
                                    <div key={index} className='row'>
                                        {elem.map((cell, cellIndex) => {
                                            return (
                                                <div key={`${index}-${cellIndex}`} className='cell'>{cell}</div>
                                            )
                                        })}
                                    </div>
                                )
                            }
                            return (
                                <div key={index} className={`cell ${index === 0 ? 'first-letter' : 'value'}`}>{elem}</div>
                            )
                        })}
                    </div>
                    : null
                }
            </div>
        )
    }

    static renderContent(pageNo, props, data) {
        const name = props.tabs['property-information-tab'].tables['general-information'].rows['property-name'].value;
        const address = props.tabs['property-information-tab'].tables['general-information'].rows['address'].value;
        const city = props.tabs['property-information-tab'].tables['general-information'].rows['city'].value;
        const state = props.tabs['property-information-tab'].tables['general-information'].rows['state'].value;
        const zip = props.tabs['property-information-tab'].tables['general-information'].rows['zip'].value;
        const photo = arc.path.media + props.propertyImage;

        switch (pageNo) {
            case 1:
                return (
                    <div className='content'>
                        <div className='left-container'>
                            <div className='name'>{name}</div>
                            <div className='address'>{address}</div>
                            <div className='address'>{`${city}, ${state} ${zip}`}</div>
                            {PrintMultiTenant.renderTable(data.offeringSummary)}
                            <div id='map'/>
                        </div>
                        <div className='right-container'>
                            {PrintMultiTenant.renderTableMatrix(data.incomeAndExpenses, 'income-expenses')}
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className='content row'>
                        {PrintMultiTenant.renderTableMatrix(data.rentRoll, 'rent-roll')}
                        {props.propertyImage && data.rentRoll.rows.length <= 6 ?
                            <div className='property-image'>
                                <img src={photo} alt=''/>
                            </div>
                            :
                            null
                        }
                    </div>
                );
        }
    }

    static renderPage(pageNo, props, data, agents) {
        return (
            <div className='page' style={{backgroundImage: `url(${arc.path.media}stnl-background.png)`}}>
                <div className='head'>
                    <div className='logo'>
                        <img src={`${arc.path.media}strive-logo.png`} alt=''/>
                    </div>
                </div>
                {PrintMultiTenant.renderContent(pageNo, props, data)}
                <div className='footer'>
                    {agents && agents.length ?
                        agents.map(agent => {
                            return (
                                <div key={agent.id}>
                                    <div className='name'>{agent.name}</div>
                                    <div className='details'>
                                        <div>{agent.phone}</div>
                                        <div className='line'/>
                                        <div>{agent.email}</div>
                                    </div>
                                </div>
                            )
                        }) : null
                    }
                </div>
            </div>
        );
    }

    render() {
        const data = this.state.data;
        const agents = this.props.agents;

        return (
            <div className='PrintMultiTenant'>
                {PrintMultiTenant.renderPage(1, this.props, data, agents)}
                {PrintMultiTenant.renderPage(2, this.props, data, agents)}
            </div>
        )
    }
}
